import { APICallV1 } from 'reactApp/api/APICall';

export class RestoreStatusCheckAPICall extends APICallV1 {
    _method = 'necromancer/get_state';
    _type = 'get';
}
